<template>
  <div class="section pt-5">
    <div v-if="patient">
      <div class="title is-4">{{ $t("patient") }} {{ patient.name }}</div>
      <div class="subtitle is-6 mb-0" v-if="patient.phone">
        <span class="icon">
          <i class="fa fa-phone"></i>
        </span>
        <span>{{ patient.phone }}</span>
      </div>
      <div class="subtitle is-6" v-if="patient.email">
        <span class="icon">
          <i class="fa fa-envelope"></i>
        </span>
        <span>{{ patient.email }}</span>
      </div>
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            class="is-active"
            data-tab="appointments"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="calendar icon" aria-hidden="true"></i>
              <span>{{ $t("appointments") }}</span>
            </a>
          </li>
          <li
            data-tab="hospitalization"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="hospital icon" aria-hidden="true"></i>
              <span>{{ $t("hospitalization") }}</span>
            </a>
          </li>
          <li data-tab="documents" @click="change_active_tab($event, this)">
            <a>
              <i class="file image icon mb-0" aria-hidden="true"></i>
              <span>{{ $t("documents") }}</span>
            </a>
          </li>
          <li
            data-tab="medical_services"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="doctor icon" aria-hidden="true"></i>
              <span>{{ $t("medical services") }}</span>
            </a>
          </li>
          <li data-tab="prescriptions" @click="change_active_tab($event, this)">
            <a>
              <i class="file text icon mb-0" aria-hidden="true"></i>
              <span>{{ $t("prescriptions") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="" data-tab="appointments">
          <appointments ref="appointments" />
        </div>
        <div class="is-hidden" data-tab="hospitalization">
          <hospitalization ref="hospitalization" />
        </div>
        <div class="is-hidden" data-tab="documents">
          <documents ref="documents" />
        </div>
        <div class="is-hidden" data-tab="medical_services">
          <medical-services ref="medical_services" />
        </div>
        <div class="is-hidden" data-tab="prescriptions">
          <prescriptions ref="prescriptions" />
        </div>
      </div>
      <!-- <pre>{{ patient }}</pre> -->
    </div>
    <div v-else>
      <div class="notification is-danger">
        <button class="delete" @click="refresh"></button>
        {{ $t("patient_not_found") }}
      </div>
    </div>
  </div>
</template>

<script>
import { get, error_message, change_active_tab } from "@/utils";
import Appointments from "./profile_components/appointments/Index.vue";
import Hospitalization from "./profile_components/hospitalization/Index.vue";
import Documents from "./profile_components/documents/Index.vue";
import MedicalServices from "./profile_components/medical_services/Index.vue";
import Prescriptions from "./profile_components/prescriptions/Index.vue";

export default {
  name: "PatientProfile",
  components: {
    Appointments,
    Hospitalization,
    Documents,
    MedicalServices,
    Prescriptions,
  },
  data() {
    return {
      patient: {},
    };
  },
  methods: {
    change_active_tab,
    refresh() {
      let v = this;
      get("/patient/details", { uuid: v.$route.params.patient_uuid })
        .then((patient) => {
          v.patient = patient;
          v.$refs.appointments.refresh();
          v.$refs.hospitalization.refresh();
          v.$refs.documents.refresh();
          v.$refs.medical_services.refresh();
          v.$refs.prescriptions.refresh();
        })
        .catch((error) => {
          v.patient = undefined;
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
  created() {},
};
</script>

<style scoped></style>
